export default {
  path: '/join-info2',
  meta: {
    title: '联盟商家入驻',
  },
  component: r => require.ensure([], () => r(require(`./index.vue`)), `/join-info2`),
}



// WEBPACK FOOTER //
// ./src/views/joinInfo2/router.js